/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Typography } from 'antd';
import clsx from 'clsx';

import s from './styles.module.less';

export default ({ className, ...props }) => <Typography.Title className={clsx(s.pageTitle, className)} {...props} />;
